/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import Divider from 'material-ui/Divider';
import Typography from 'material-ui/Typography';
import $ from 'jquery';
import LINK from '../constants/LinkConstants.js';


class Confirmation extends React.Component {

  constructor(props) {
     super(props);
     if(props.fields){
       this.state = props.fields;
     }
     this.sendEmail(props.emailString);
  }

  sendEmail(emailString){
    $.ajax({
     url: LINK.sendEmailToAdmin,
     cache: false,
     type : 'POST',
     data : (emailString),
     headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json'
     },
     success: function(response) {

     }.bind(this),
     error: function(xhr, status, err) {

     }.bind(this)
   });
  }

  validateNow = ()  => {

  }

  render() {

    return (
      <div>
        <Divider light />
        <Typography type="title" className="headline">Account Confirmation</Typography>
        <br/>
        <table border="0" cellPadding="2" cellSpacing="2" width="100%">
          <tbody>
            <tr>
              <td>
                {this.state.signOrder?(
                  <div>
                    Your application was successfully processed.
                    You have elected to be billed via purchase order and understand that this
                    option is only for accounts sending more than 500,000 email transmissions per month. If
                    your account fails to meet this requirement, you will be asked to keep a credit card on file
                    for billing purposes.  Please sign and fax the purchase order downloaded during the
                    signup process to (301) 990-9856. You will be notified immediately if our pricing scale
                    changes for any reason.<br/><br/>
                    Before you can start using your eLoop account, Gold Lasso will contact you
                    within 12 to 24 hours via phone to confirm your registration and that you
                    understand our terms of service. In the meantime if you have any questions
                    please call us at (301)-990-9857
                  </div>
                ):(
                  <div></div>
                )}
              </td>
            </tr>
            <tr><td><br/></td></tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default Confirmation;



// WEBPACK FOOTER //
// ./src/components/confirmation.js